import { t } from '@lingui/core/macro';

import type {
  KPINotificationType,
  PageMetaNotificationNameType,
} from '@/api/settings/settingsType';

type AttributionKPINameType =
  | 'attribution-pipeline'
  | 'attribution-closed-won'
  | 'attribution-visits-per-opp'
  | 'attribution-non-digital-events'
  | 'attribution-averagedeal-cycle';

export const attributionGoalKPIs = (): Partial<
  Record<PageMetaNotificationNameType, KPINotificationType<AttributionKPINameType>[]>
> => ({
  attribution: [
    { value: 'attribution-pipeline', label: t`Pipeline`, allowsAudience: false },
    { value: 'attribution-closed-won', label: t`Closed Won`, allowsAudience: false },
    { value: 'attribution-visits-per-opp', label: t`Visits per Opp`, allowsAudience: false },
    {
      value: 'attribution-non-digital-events',
      label: t`Non-Digital Events per Opp`,
      allowsAudience: false,
    },
    {
      value: 'attribution-averagedeal-cycle',
      label: t`Average Deal Cycle Length`,
      allowsAudience: false,
    },
  ],
});
